export default "__VITE_ASSET__CUQXeOmU__"